import numeral from 'numeral';

export const currencyDisplay = (amount) => numeral(amount).format('$0,0.00');
